module.exports = __webpack_public_path__ + "static/media/test.43e90790.jpg";